import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './components/Login';
import Registration from "./components/sign-up/Registration";
import ForgotPassword from './components/Passwords/ForgotPassword';
import ResetPassword from './components/Passwords/ResetPassword';
import AdminRoutes from './routes/AdminRoutes';
import ClientRoutes from './routes/ClientRoutes';
import EmployeeRoutes from './routes/EmployeeRoutes';
import CandidateRoutes from './routes/CandidateRoutes';
import ConfirmAccount from './components/ClientModule/ConfirmAccount';
import ServiceDown from './components/service-down/ServiceDown';
import CandidateDashboard from "./components/candidate/CandidateDashboard/candidate-Dashboard";
import ScrollToTop from './components/ScrollToTop';
import ChatbotWidget from "./components/candidate/chatbotwidget/ChatbotWidget";
import Callback from './components/candidate/callback/Callback';
import CandidateDetails from './components/admin/candidate-details/CandidateDetails';

const ChatbotWrapper = () => {
  const location = useLocation();
  return location.pathname.startsWith("/candidate") ? <ChatbotWidget /> : null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Registration" element={<Registration />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/confirm-account" element={<ConfirmAccount />} />

        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/client/*" element={<ClientRoutes />} />
        <Route path="/employee/*" element={<EmployeeRoutes />} />
        <Route path="/candidate/*" element={<CandidateRoutes />} />
        <Route path="/client/dashboard/:candidateId" element={<CandidateDashboard />} />

        <Route path="/service-down/:service" element={<ServiceDown />} />
        <Route path="/digilocker/callback" element={<Callback />} />
        <Route path="/candidate-details/:candidateId" element={<CandidateDetails />} />
        {/* fallback */}
        <Route path="*" element={<ServiceDown />} />
      </Routes>

      <ChatbotWrapper />

      <ToastContainer position="top-right" autoClose={3000} />
    </Router>
  );
}

export default App;
